// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3eVS1","title":"AfterBackImages_title__3YGeV","images":"AfterBackImages_images__2tMPu"};